module.exports = {
  //HERO
  justAskArray: [
    'USC',
    'Yale',
    'Wawa',
    'Stanford',
    'Taylor',
    'Northwestern',
    'Corrigo',
    'Texas DOT',
    'Brown University',
    'Wayfair',
    'City of Anaheim',
    'SLAC',
    'Kent State',
    'CalTech',
    'Fresno County',
    'McGill',
    'Accruent',
    'Michigan State',
    'Georgia Tech',
    'Service Master',
    'Fermilab'
  ],
  //  FEATURES section
  featureMain:
    'AppTree is an enterprise app platform that accelerates your business by solving common enterprise app build, deploy and support challenges.\n' +
    '\n' +
    'Every feature in our platform is one more problem you don’t have to solve.',
  blockOne__Title: 'Performance',
  blockOne__Description:
    'AppTree was designed for use with  large data sets and high volume transaction apps.  Use our smart caching to buffer performance problems that might exist elsewhere in your enterprise making your apps run faster and improve user experience.',
  blockTwo__Title: 'Apps Work Offline',
  blockTwo__Description:
    'Your business applications and data requirements don’t go away when you lose a network connection. Your users don’t need to think about their network coverage or signal strength. Apps built on AppTree work as well offline as they do with a continuous network connection.',
  blockThree__Title: 'Security',
  blockThree__Description:
    'Your enterprise application and data security policies are comprehensive.  AppTree provides solutions to all your security needs without writing custom code.',
  blockFour__Title: 'Low Code',
  blockFour__Description:
    'AppTree is a low code platform.  Accelerate your development by using our layout editor and built-in business logic editor to add workflows and validations.',
  blockFive__Title: 'Cross Platform',
  blockFive__Description:
    'Apps built on AppTree run natively on iOS and Android devices and on any device or desktop computer with a web browser.  You build it once and it runs on everything.',
  blockSix__Title: 'Integrations',
  blockSix__Description:
    'You have existing business applications and data.  AppTree has connectors to many enterprise systems and an SDK for quickly building new connectors.',
  callToActionText: 'Learn More About What AppTree Can Do',
  //  CHECKLIST SECTION
  checklistItems: [
    'Inspections',
    'Shopping Carts',
    'Call Centers',
    'Timecards',
    'Asset Moves',
    'Integrations',
    'Work Management',
    'Customer Service',
    'Part Catalogs',
    'Preventative Maintenance',
    'Space Surveys',
    'Property Management',
    'Compliance',
    'Access and Key Control',
    'Utility Meter Reading',
    'Space Management',
    'Requesting Services',
    'Inventory Management',
    'Part Orders',
    'Shipping',
    'Taxation',
    'Labor Entry',
    'Activity Timers',
    'Scheduling',
    'Dispatching',
    'Customer Survey',
    'Business Intelligence'
  ]
}



// WEBPACK FOOTER //
// ./data/indexContent.js